module.exports = __webpack_public_path__ + "img/bear.b1013a0d.png";